import socket from './init';
import './handlers';

export default socket;
